var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.initialized
    ? _c(
        "section",
        {
          staticClass: "box-typical box-typical-dashboard panel panel-default"
        },
        [
          _c("header", { staticClass: "box-typical-header panel-heading" }, [
            _c("h3", { staticClass: "panel-title" }, [
              _vm._v(_vm._s(_vm.label))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "box-typical-body panel-body" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._.isEmpty(_vm.itemData)
                ? _c("div", { class: ["alert", "alert-info", "m-3"] }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.emptyText || "No record") +
                        "\n        "
                    )
                  ])
                : _vm._l(_vm.itemData, function(item) {
                    return _c(
                      "article",
                      { key: item.id, staticClass: "comment-item" },
                      [
                        _c("div", { staticClass: "user-card-row" }, [
                          _c("div", { staticClass: "tbl-row" }, [
                            _c("div", {
                              staticClass: "tbl-cell cell-date",
                              domProps: { innerHTML: _vm._s(item.datetime) }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "tbl-cell cell-name" }, [
                              _c(
                                "span",
                                { staticClass: "user-card-row-name" },
                                [
                                  _c("a", {
                                    attrs: { href: item.link },
                                    domProps: { innerHTML: _vm._s(item.title) }
                                  }),
                                  _c("br")
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "tbl-cell",
                              domProps: { innerHTML: _vm._s(item.status) }
                            })
                          ])
                        ])
                      ]
                    )
                  })
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "user-card-row user-card-header" }, [
      _c("div", { staticClass: "tbl-cell" }, [
        _vm._v("\n                Date & Time\n            ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tbl-cell cell-name" }, [
        _vm._v("\n                Name & Email\n            ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tbl-cell" }, [
        _vm._v("\n                Status\n            ")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-048b4bfa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-048b4bfa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/dashboard-elements/ContentListPanelComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-048b4bfa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/dashboard-elements/ContentListPanelComponent.vue
// module chunks = 0